module.exports = __webpack_public_path__ + "5a08619472ac42f375d8f49a63d3c977.svg";